// import { defaultLatLng } from "../constants"

// const pointStringToLatLng = (pointString) => {
//   "We want to convert a string of the form '(lat,lng)' to a latLng list"
//   const [lat, lng] = pointString.replace("(", "").replace(")", "").split(",")
//   return [parseFloat(lng), parseFloat(lat)]
// }

export const allFarmsToGeoJson = (farms) => {
  const farmsGeoJson = farms
    .filter(farm => farm.geo_location?.geo_json)
    .map((farm) => {
      return {
        type: "Feature",
        geometry: {
          ...farm.geo_location.geo_json,
        },
        properties: {
          title: farm.name,
          description: farm.description,
          id: farm.id,
        },
      }
    })

  return {
    type: "FeatureCollection",
    features: [...farmsGeoJson],
  }
}

export const farmAreaToGeoJSON = (farmAreas, activeArea, activeLine, activeMark) => {
  const geoJson = {
    type: "FeatureCollection",
    features: [
      ...farmAreas
        .filter(area => area.geo_location?.geo_json)
        .map((area) => ({
          type: "Feature",
          geometry: { ...area.geo_location.geo_json },
          id: area.id,
          properties: {
            // Area is only visually active if it's the activeArea AND there's no active line or mark
            active: (activeArea === area.id && !activeLine && !activeMark) ? "true" : "false",
          },
      })),
    ],
  }
  return geoJson
}

export const growingLineToGeoJSON = (farmAreas, activeLine) => {
  if (!farmAreas || !Array.isArray(farmAreas)) {
    return {
      type: "FeatureCollection",
      features: [],
    }
  }

  const linesWithIds = farmAreas.map((area) => ({
    ...area,
    geographic_features: area?.geographic_features
      ?.filter(feature => feature?.type === "growing_line")
      ?.map((line) => ({
        ...line,
        area_id: area.id,
      })) || [],
  }))
  
  const growingLines = linesWithIds?.reduce((acc, area) => {
    return [...acc, ...(area?.geographic_features || [])]
  }, [])

  const geoJson = {
    type: "FeatureCollection",
    features: growingLines
      ?.filter(line => line?.geo_json && line?.id)
      ?.map((line) => ({
        type: "Feature",
        geometry: line.geo_json,
        id: line?.id,
        properties: {
          active: activeLine === line?.id ? "true" : "false",
          area_id: line?.area_id,
          featureType: "growing_line",
          name: line?.name || "Unnamed Line",
        },
      })) || [],
  }
  return geoJson
}

export const marksToGeoJSON = (farmAreas, activeMark) => {
  if (!farmAreas || !Array.isArray(farmAreas)) {
    return {
      type: "FeatureCollection",
      features: [],
    }
  }

  const marksWithIds = farmAreas.map((area) => ({
    ...area,
    geographic_features: area?.geographic_features
      ?.filter(feature => feature?.type === "marker_point")
      ?.map((mark) => ({
        ...mark,
        area_id: area.id,
      })) || [],
  }))
  
  const marks = marksWithIds?.reduce((acc, area) => {
    return [...acc, ...(area?.geographic_features || [])]
  }, [])

  const geoJson = {
    type: "FeatureCollection",
    features: marks
      ?.filter(mark => mark?.geo_json && mark?.id)
      ?.map((mark) => ({
        type: "Feature",
        geometry: mark.geo_json,
        id: mark?.id,
        properties: {
          active: activeMark === mark?.id ? "true" : "false",
          area_id: mark?.area_id,
          featureType: "mark",
          name: mark?.name || "Unnamed Mark",
        },
      })) || [],
  }
  return geoJson
}

export const latLngArrayToGeoJSON = (latLngArray) => {
  return {
    newLocation: {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            ...latLngArray.map((latLng) => [
              parseFloat(latLng.lng),
              parseFloat(latLng.lat),
            ]),
            // add the first element again to finish the ring
            [parseFloat(latLngArray[0].lng), parseFloat(latLngArray[0].lat)],
          ],
        ],
      },
    },
  }
}
